<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 20:06:33
 * @Description: 近30日储能充放电量
 * @FilePath: \sheyang\src\module\energyStorage\rightContent\recentMonthPower.vue
-->
<template>
  <div class="recent-month-power">
    <div style="width: 100%;cursor: pointer" @click="handleNavGo">
      <pub-info-title :title="'近30日储能充/放电量'" />
    </div>
    <div ref="powerLine" class="power-line-chart"></div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import pubInfoTitle from '@/components/infoTitle/index.vue';

export default {
  name: 'recentMonthPower',
  components: {
    pubInfoTitle,
  },
  props: {
    chargingInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chargingInfo: {
      handler() {
        this.lineChartsInit();
      },
      deep: true,
    },
  },
  mounted() {
    this.lineChartsInit();
    window.addEventListener('resize', () => {
      this.chart.resize();
    });
  },
  methods: {
    lineChartsInit() {
      const dataX = [];
      for (let i = 1; i < 31; i++) {
        const str = i < 10 ? `0${i}` : i;
        dataX.push(str);
      }
      this.chart = Echarts.init(this.$refs.powerLine);
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params)=>{
            let str=`<div>${params[0].name}</div>`
            params.forEach(item => {
              str+=`<div style='display:flex;'>
                      <div>${item.marker} </div>
                      <div style='width:70px'>${item.seriesName}</div>
                      <div style='font-weight:600;'>${(item.value).toFixed(0)}</div>
                    </div>`
            });
            return str
          }
        },
        legend: {
          data: ['充电量', '放电量'],
          itemHeight: this.fitChartSize(0),
          top: this.fitChartSize(-4),
          itemGap: this.fitChartSize(19),
          textStyle: {
            color: '#CCCCCC',
            fontSize: this.fitChartSize(12),
          },
        },
        grid: {
          top: this.fitChartSize(30),
          left: '2%',
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: ['5%', '5%'],
          // data: dataX,
          data: this.chargingInfo.xAxisDate,
          axisTick: {
            show: false, // x 轴刻度是否显示
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#9A9A9A',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(14),
          },
        },
        yAxis: {
          name: 'kWh',
          nameLocation: 'end',
          nameTextStyle: {
            color: '#fff',
            align: 'right',
            fontSize: this.fitChartSize(12),
            padding: [0, 2, 0, 0],
          },
          type: 'value',
          axisLabel: {
            color: '#C5C5C5',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(6),
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: 'rgba(43, 196, 255, 0.5)',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            name: '充电量',
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#32BAFF',
              shadowColor: '#32BAFF',
              shadowBlur: 8,

            },
            lineStyle: {
              color: '#32BAFF',
            },
            // 线条下方区域颜色
            areaStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(48, 183, 255, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(3, 132, 255, 0)',
                },
              ]),
            },
            // data: this.chargingInfo.storedChargingAmount,
            data: [
              41, 46, 53, 44, 88, 72, 63, 50, 37, 70, 64, 34, 88, 30, 37, 76, 31, 29, 72, 49, 54, 39, 30, 30, 31, 31, 19, 57, 104, 6, 18,
            ],
          },
          {
            name: '放电量',
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#FF9C59',
              shadowColor: 'rgba(255, 156, 89, 1)',
              shadowBlur: 8,
            },
            lineStyle: {
              color: '#FF9C59',
            },
            // 线条下方区域颜色
            areaStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(255, 156, 89, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(255, 156, 89, 0)',
                },
              ]),
            },
            // data: this.chargingInfo.storedDisChargingAmount,
            data: [
              7, 38, 47, 48, 71, 62, 53, 17, 59, 33, 53, 54, 41, 53, 22, 26, 77, 24, 61, 34, 22, 56, 30, 24, 25, 24, 12, 15, 48, 2, 12,
            ],
          },
        ],
      };
      this.chart.setOption(option);
    },
    handleNavGo() {
      this.$emit('handleNavGo');
    },
  },
};
</script>

<style lang="less" scoped>
.recent-month-power {
  ::v-deep .pub-info-title {
    margin-bottom: 20px;
  }
  .power-line-chart {
    width: 100%;
    height: 235px;
    margin-bottom: 12px;
  }
}
</style>
